import { render, staticRenderFns } from "./NotQualified.vue?vue&type=template&id=a74d966c&scoped=true&"
import script from "./NotQualified.vue?vue&type=script&lang=js&"
export * from "./NotQualified.vue?vue&type=script&lang=js&"
import style0 from "./NotQualified.vue?vue&type=style&index=0&id=a74d966c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74d966c",
  null
  
)

export default component.exports